declare global {
  interface Navigator {
    msSaveOrOpenBlob?: (blob: any, defaultName?: string) => boolean;
  }
}
export function downloadFile(data: any, fileType: string, fileName: string) {
  const blob: Blob = new Blob([data], { type: fileType }),
    dataURL: string = window.URL.createObjectURL(blob);

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, fileName);
    return;
  }

  const link: HTMLAnchorElement = document.createElement('a');
  link.href = dataURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    document.body.removeChild(link);
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(dataURL);
  }, 100);
}

export const downloadZipFile = (file: Blob, fileName: string): void => {

  if (!file) {
    const blankBlob = new Blob([], { type: 'application/zip' });
    file = blankBlob;
  }

  // IE doesn't allow using a blob object directly as link href
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(file, fileName);
    return; // Exit the function after handling IE
  }
  const dataURL = window.URL.createObjectURL(file);

  const link: HTMLAnchorElement = document.createElement('a');
  link.href = dataURL;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
  window.URL.revokeObjectURL(dataURL);
}

